import { getPlainToken } from "../assets/Js/tokenHandler";
import { callAPI } from "../assets/Js/backendCommunication";
import projectSettings from "../assets/Js/projectSettings";

export default async function doesUserHasUnreadMessages(
  callThisFunctionOnSuccess
) {
  let url = `${projectSettings.baseUrl}/chats/UnreadMessages`;
  let header = true;
  let type = "GET";
  let data = null;
  let token = getPlainToken();
  let response = "";

  response = await callAPI(url, header, type, JSON.stringify(data), token);

  if (response) {
    if (response.type === "error") {
    } else if (response.type === "success") {
      if (response?.data?.IsUnReads) {
        callThisFunctionOnSuccess();
      }
    }
  }
}
